import styled from "styled-components";
import {
  Avatar,
  avatarUserTypes,
  componentSizes
} from "@streeteasy/design-system";

export const AgentImage = styled(Avatar).attrs({
  alt: "",
  size: componentSizes.SM,
  userType: avatarUserTypes.PARTNER
})`
  border-radius: 50%;
  height: 65px;
  object-fit: cover;
  width: 65px;
`;

export const AgentDescriptionHeader = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

export const AgentInfoContainer = styled.div`
  margin-left: 24px;
`;
